'use client';

import { useTranslations } from 'next-intl';
import { usePwaInstall } from '@/components/features/pwa/PwaInstallProvider';
import Toast from '@/components/ui/Toast/toast';
import NavigationItem from './NavigationItem';

interface Props {
  handleCloseSideBar: () => void;
}

export default function PwaInstallNavigationItem({ handleCloseSideBar }: Props) {
  const t = useTranslations('pwa');
  const { isStandalone, startInstallFlow } = usePwaInstall();

  const handleClick = () => {
    if (isStandalone) {
      Toast({
        id: 'pwa-already-installed',
        type: 'info',
        title: t('already-installed-title'),
      });
      handleCloseSideBar();
      return;
    }

    startInstallFlow();
    handleCloseSideBar();
  };

  return (
    <NavigationItem
      label={t('sidebar-install-action')}
      icon="download"
      onClick={handleClick}
      variant="account"
    />
  );
}
